import * as components from '../helpers/imports/FindabilityComponents'
import CMSComponents, { GetComponent } from './CMSComponents'

export { components, GetComponent }
export default CMSComponents
